import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

interface AddMembersToTeamParams {
  teamId: number;
  userIds: number[];
}

export const useAddMembersToTeam = () => {
  const queryClient = useQueryClient();

  const addMembersToTeam = async ({
    teamId,
    userIds
  }: AddMembersToTeamParams) => {
    const url = POST_URL(teamId.toString()).addMembersToTeam;
    const response = await Axios.post(url, { user_ids: userIds.map(String) });
    return response.data;
  };

  return useMutation(addMembersToTeam, {
    onSuccess: () => {
      queryClient.invalidateQueries('teamUsers');
    }
  });
};
